<template>
	<v-container fluid grid-list-lg class="pa-3">
		<v-layout row wrap>
			<v-flex xs12 sm4 md3 lg2>
				<v-card class="pa-2">
					<v-timeline align-top dense>
						<v-timeline-item color="primary" small>
							<v-layout  pt-3>
								<v-flex>
									<strong>Start</strong>
									<div class="caption">
										{{ fpes_appraisal_ack_rec.created_by }} <br />
										{{ epoch2localedatetime(fpes_appraisal_ack_rec.created) }}
									</div>
								</v-flex>
							</v-layout>
						</v-timeline-item>

						<v-timeline-item color="dull_mid" small v-if="current_step==1">
							<v-layout pt-3>
								<v-flex>
									<strong>Pending <u>{{ fpes_appraisal_ack_rec.username}}</u>  Acknowledgement</strong>
									<div class="caption">
										<v-btn outline block color="error" small v-show="current_username == fpes_appraisal_ack_rec.username" @click="appraisee_acknowledge_onclick(2,'reject')">
											<v-icon left>unpublished</v-icon>
											Reject
										</v-btn>

										<v-btn block color="primary" small v-show="current_username == fpes_appraisal_ack_rec.username" @click="appraisee_acknowledge_onclick(2,'acknowledge')">
											<v-icon left>task_alt</v-icon>
											Acknowledge
										</v-btn>
									</div>
								</v-flex>
							</v-layout>
						</v-timeline-item>

						<v-timeline-item color="primary" small v-else>
							<v-layout pt-3>
								<v-flex>
									<strong><span v-html="getAppraiseeAckStatus(fpes_appraisal_ack_rec.appraisee_ack_status_id)"></span> Acknowledgement</strong>
									<div class="caption">
										{{ fpes_appraisal_ack_rec.appraisee_username }} <br />
										{{ epoch2localedatetime(fpes_appraisal_ack_rec.appraisee_ack_epoch) }}
									</div>
								</v-flex>
							</v-layout>
						</v-timeline-item>

						<v-timeline-item color="dull_mid" small v-if="current_step==2">
							<v-layout pt-3>
								<v-flex>
									<strong>Pending Superior Acknowledgement</strong>
									<div class="caption">
										<v-btn block color="primary" small v-show="current_username != fpes_appraisal_ack_rec.username" @click="appraisee_acknowledge_onclick(3,'')">
											<v-icon left>task_alt</v-icon>
											Acknowledge
										</v-btn>
									</div>
								</v-flex>
							</v-layout>
						</v-timeline-item>

						<v-timeline-item color="primary" small v-else-if="current_step>=3">
							<v-layout pt-3>
								<v-flex>
									<strong>Superior Acknowledged</strong>
									<div class="caption">
										{{ fpes_appraisal_ack_rec.superior_username }} <br />
										{{ epoch2localedatetime(fpes_appraisal_ack_rec.superior_ack_epoch) }}
									</div>
								</v-flex>
							</v-layout>
						</v-timeline-item>

						<v-timeline-item color="primary" small v-if="current_step==4">
							<v-layout pt-3>
								<v-flex>
									<strong>End</strong>
									<div class="caption">
										{{ epoch2localedatetime(fpes_appraisal_ack_rec.modified) }}
									</div>
								</v-flex>
							</v-layout>
						</v-timeline-item>
					</v-timeline>
				</v-card>
			</v-flex>

			<v-flex xs12 sm8 md9 lg10>
				<v-card>
					<v-tabs v-model="tabs.active" slider-color="primary">
						<v-tab v-for="(n, i) in tabs.tabs_name" :key="i" ripple active-class="primary--text font-weight-black">
							{{ n.name }}({{ n.rev }})
						</v-tab>
						<v-tab-item v-for="(n, i) in tabs.contents" :key="i">
							<v-card flat>
								<v-card-text v-html="n"></v-card-text>
							</v-card>
						</v-tab-item>
					</v-tabs>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import general from "../../functions/general";
import auth from "../../functions/auth";

const review_plan_setting = [
	{
		"question": "(1) What have you accomplished over the last 4 or 12 months?",
		"map_key": "R1_accomplishment"
	},
	{
		"question": "(2) Which task brings you the most satisfaction over the last 4 or 12 months?",
		"map_key": "R2_satisfaction"
	},
	{
		"question": "(3) What has been the biggest disappointment over the last 4 or 12 months?",
		"map_key": "R3_disappointment"
	},
	{
		"question": "(4) What would you like to accomplish in the next 4 or 12 months?",
		"map_key": "R4_plan"
	}
];

const engagement_setting = [
	{
		"question": "(1) How likely would you recommend the services of MYCO2 to a friend or relative?",
		"map_key": "E1_rating"
	},
	{
		"question": "(2) If your rating above is 1 to 6 above, what’s one thing we’re doing that’s holding you back from recommending?",
		"map_key": "E2_recommendation"
	}
];

export default {
	name: "Appraisal-Acknowledgement-Page",
	async mounted() {
		general.App.loader.show(this);
		var fpes_report_entries_id = general.App.getQueryString("fpes_report_entries_id");
		general.App.set_page_title("mySuite : Appraisal Acknowledgement Page");
		this.current_username = auth.getUsername();

		await this.loadAppraisalAckowledgement(fpes_report_entries_id);
		general.App.loader.hide(this);
	},
	computed: {},
	data() {
		return {
			fpes_appraisal_ack_rec: {},
			all_appraisals_data: [],
			all_status:[],
			all_appraisee_ack_status:[],
			all_form_info:[],
			current_step:0,
			current_username:"",
			tabs: {
				active: 0,
				tabs_name: [],
				contents: [],
			},
		};
	},
	methods: {
		epoch2localedatetime: general.App.epoch2LocaleDatetime,
		async loadAppraisalAckowledgement(fpes_report_entries_id) {
			var res = await general.wBackEndComm.GetData("fpes/load_ackowledgement_record/?fpes_report_entries_id=" + fpes_report_entries_id);

			res = res.data;
			if (res.Status == 1) {
				this.fpes_appraisal_ack_rec = res.Body.fpes_appraisal_ack_rec;
				this.all_status = res.Body.all_status;
				this.all_appraisee_ack_status = res.Body.all_appraisee_ack_status;
				this.all_form_info = res.Body.all_form_info;
				this.current_step = this.all_status.filter(el => el._id == this.fpes_appraisal_ack_rec.status_id)[0].order;

				var temp_data = res.Body.all_appraisals_data.filter(el => {
					return !el.submission.data.type.name.includes("Peer");
				});

				var all_data = {};
				for (let index = 0; index < temp_data.length; index++) {
					const el = temp_data[index];

					all_data[el.form_id] == undefined ? all_data[el.form_id] = [el] : all_data[el.form_id].push(el);
				}
				this.all_appraisals_data = all_data;
				this.start_process_acknowledgement();
			}
		},
		start_process_acknowledgement() {
			this.tabs.tabs_name = Object.keys(this.all_appraisals_data);

			for (let index = 0; index < this.tabs.tabs_name.length; index++) {
				const tab_name = this.tabs.tabs_name[index];

				this.tabs.contents.push(this.process_tab_data(this.all_appraisals_data[tab_name]));
				
				var temp = this.all_form_info.find((el)=>el._id == tab_name);
				
				this.tabs.tabs_name[index] = temp;
			}
		},
		process_tab_data(appraisals_data) {
			const total_appraisals = appraisals_data.length;
			var html_table_arr = ["<table class='appraisal-table'>"];

			// START table header
			html_table_arr.push("<thead><tr class='appraisal-table__header'>");
			html_table_arr.push("<th style='text-align:left'>Appraisal Question</th>");
			for (let index = 0; index < total_appraisals; index++) {
				var appraisal = appraisals_data[index];				
				var type = appraisal.submission.data.type.name.includes("Self") > 0 ? "Self" : "Sup";
				var year = appraisal.submission.data.year.name;
				var qtr = appraisal.submission.data.quater.name;
				
				html_table_arr.push(`<th style='width:4%;' title='${appraisal._id}'>${type}${index + 1}<br/>${year}<br/>${qtr}</th>`);
			}
			html_table_arr.push("</tr></thead>");
			// END table header

			// START table body
			html_table_arr.push(this.extract_appraisal_questions(appraisals_data, total_appraisals));
			// END table body

			html_table_arr.push("</table>");

			html_table_arr.push("<br/>");

			// START review plan table
			html_table_arr.push(this.extract_review_plan(appraisals_data, total_appraisals));
			// END review plan table

			html_table_arr.push("<br/>");

			// START engagement table
			html_table_arr.push(this.extract_engagement(appraisals_data, total_appraisals));
			// END engagement table

			return html_table_arr.join("");
		},
		extract_appraisal_questions(appraisals_data, y_axis) {
			var t_result = [];
			var all_questions = Object.keys(appraisals_data[0].submission.data.appraisal);

			t_result.push("<tbody class='appraisal-table__body'>");
			for (let index = 0; index < all_questions.length; index++) {
				const question = all_questions[index];
				t_result.push("<tr>");
				t_result.push("<td style='text-align:left'>" + question + "</td>"); // question name

				for (let index = 0; index < y_axis; index++) {
					const el = appraisals_data[index];
					var answer = el.submission.data.appraisal[question];
					answer = answer == undefined ? "" : answer;
					t_result.push("<td>" + answer + "</td>"); // answer
				}
				t_result.push("</tr>");
			}

			t_result.push("<tr style='font-weight: bolder;font-size:13px;'>");
			t_result.push("<td style='text-align:right;'>Score</td>");
			for (let index = 0; index < appraisals_data.length; index++) {
				const el = appraisals_data[index];

				t_result.push(`<td>${el.submission.data.ave_score}</td>`);
			}
			t_result.push("</tr>");
			t_result.push("</tbody>");

			return t_result.join("");
		},
		extract_review_plan(appraisals_data, y_axis) {
			var t_result = ["<table class='appraisal-table' style='text-align: left;'>"];

			t_result.push("<thead><tr class='appraisal-table__header'>");
			t_result.push("<th style='text-align:left'>Review & Plan</th></tr></thead>");

			t_result.push("<tbody class='appraisal-table__body'>");

			for (let index = 0; index < review_plan_setting.length; index++) {
				const review_setting = review_plan_setting[index];

				t_result.push("<tr><td>");
				t_result.push(`<b>${review_setting.question}</b>`);
				t_result.push("<ul>");

				for (let index = 0; index < y_axis; index++) {
					const el = appraisals_data[index];
					const type = el.submission.data.type.name.includes("Self") > 0 ? "Self" : "Sup";
					var year = el.submission.data.year.name;
					var qtr = el.submission.data.quater.name;
					
					t_result.push(`<li><b>${type}${index + 1} (${year} ${qtr})</b> : <i>${el.submission.data[review_setting.map_key]}</i> </li>`);
				}

				t_result.push("</ul>");
				t_result.push("</td></tr>");
			}

			t_result.push("</tbody>");
			t_result.push("</table>");

			return t_result.join("");
		},
		extract_engagement(appraisals_data, y_axis) {
			var t_result = ["<table class='appraisal-table' style='text-align: left;'>"];

			t_result.push("<thead><tr class='appraisal-table__header'>");
			t_result.push("<th style='text-align:left'>Engagement</th></tr></thead>");

			t_result.push("<tbody class='appraisal-table__body'>");

			for (let index = 0; index < engagement_setting.length; index++) {
				const review_setting = engagement_setting[index];

				t_result.push("<tr><td>");
				t_result.push(`<b>${review_setting.question}</b>`);
				t_result.push("<ul>");

				for (let index = 0; index < y_axis; index++) {
					const el = appraisals_data[index];
					const type = el.submission.data.type.name.includes("Self") > 0 ? "Self" : "Sup";
					var year = el.submission.data.year.name;
					var qtr = el.submission.data.quater.name;
					
					t_result.push(`<li><b>${type}${index + 1} (${year} ${qtr})</b> : <i>${el.submission.data[review_setting.map_key]}</i> </li>`);
				}

				t_result.push("</ul>");
				t_result.push("</td></tr>");
			}

			t_result.push("</tbody>");
			t_result.push("</table>");

			return t_result.join("");
		},
		async appraisee_acknowledge_onclick(event, acknowledge_status){
			general.App.loader.show(this);
			var res = await general.wBackEndComm.GetData(`fpes/update_ackowledgement_record_base_on_event/?fpes_appraisal_ack_id=${this.fpes_appraisal_ack_rec._id}&event=${event}&acknowledge_status=${acknowledge_status}`);

			res = res.data;
			if(res.Status == 1){
				Object.assign(this.fpes_appraisal_ack_rec, res.Body);
				this.current_step = this.all_status.filter(el => el._id == this.fpes_appraisal_ack_rec.status_id)[0].order;
			}else{
				general.wMsgBox.Error(res.Description);
			}
			general.App.loader.hide(this);
		},
		getAppraiseeAckStatus(_id){
			return `<u>${this.all_appraisee_ack_status.filter(el => el._id == _id)[0].label}</u>`;
		},
	},
};
</script>

<style>
.appraisal-table {
	/* font-family: arial, sans-serif; */
	border-collapse: collapse;
	border: 1px solid #cecece;
	width: 100%;
	text-align: center;
}

.appraisal-table thead {
	/* background-color: #f0eeee; */
	background-color: #757575;
	color: white;
}

.appraisal-table th,
.appraisal-table td {
	border: 1px solid #d1d1d1;
	/* text-align: left; */
	padding: 7px;
	word-break: break-word;
}

.appraisal-table__body {
	font-size: 12px;
}

.appraisal-table__body tr:hover {
	background-color: #9E9E9E;
	color: white;
	/* background-color: #f7f7f7; */
	border:2px solid #969696
}

li {
	padding: 3px;;
}
</style>
